import React from "react";
import styled from "styled-components";
import BaseComponent from "./BaseComponent";
import AppHeader from "./common/AppHeader";
import Avatar from "./common/AvatarImg";

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

const TextDiv = styled.h1`
  font-size: 40px;
`;

class PageNotFound extends BaseComponent {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    return (
      <>
        <AppHeader />
        <Avatar />
        <Wrapper>
          <TextDiv>Sorry, that page doesn't exist.</TextDiv>
        </Wrapper>
      </>
    );
  }
}

export default PageNotFound;
